var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23141",
    "data-name": "Path 23141",
    d: "M0,0H15V15H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23142",
    "data-name": "Path 23142",
    d: "M3.751,14.072l-.012.012-.013-.012H2.614A.613.613,0,0,1,2,13.461V3.611A.617.617,0,0,1,2.614,3H13.767a.613.613,0,0,1,.614.611v9.85a.617.617,0,0,1-.614.611Zm9.392-3.691V4.23h-9.9v8.611l6.19-6.151Zm0,1.739L9.428,8.43l-4.44,4.411h8.154Zm-7.428-4.2a1.23,1.23,0,1,1,1.238-1.23A1.234,1.234,0,0,1,5.714,7.921Z",
    transform: "translate(-0.69 -1.042)",
    fill: "#e3aa0e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLine);
export default __webpack_public_path__ + "static/media/image-line.c0c8748fe3403ad6d356869ea54450ee.svg";
export { ForwardRef as ReactComponent };